<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
            <el-form-item label="相关标段">
                {{form.bdname}}
            </el-form-item>
            <el-form-item label="候选人" v-if="model.zb">
                {{form.hxrdwname}}
            </el-form-item>
            <el-form-item label="是否联合体" :class="{'table-full-row': form.islht==='0'}">
                <span v-if="form.islht==='1'">是</span>
                <span v-if="form.islht==='0'">否</span>
            </el-form-item>
            <el-form-item label="联合体成员" v-if="form.islht==='1'">
                {{form.lhtcy}}
            </el-form-item>
            <el-form-item label="中标候选人统一信用代码" v-if="model.zb">
                {{form.hxrorgcode}}
            </el-form-item>
            <el-form-item label="统一信用代码" v-if="!model.zb">
                {{form.hxrorgcode}}
            </el-form-item>
            <el-form-item label="单位名称">
                {{form.hxrdwname}}
            </el-form-item>
            <el-form-item label="候选人所属地区" class="table-full-row" v-if="!model.zb">
                {{form.cityname}}
            </el-form-item>
            <el-form-item label="报价类型" prop="bjlx" :rules="newRule('报价类型', 'required')">
                <span v-if="form.bjlx=='1'">金额</span>
                <span v-if="form.bjlx=='2'">费率/比率/优惠率/合格率等</span>
                <span v-if="form.bjlx=='3'">单价</span>
                <span v-if="form.bjlx=='4'">其他形式</span>
            </el-form-item>
            <el-form-item label="是否进行过投标报价算术性修正">
                <span v-if="form.ssxxz==='1'">是</span>
                <span v-if="form.ssxxz==='0'">否</span>
            </el-form-item>
            <el-form-item label="中标候选人排名">
                {{form.hxrpm}}
            </el-form-item>
            <el-form-item label="投标价格(元)" v-if="form.bjlx==='1'">
                {{form.tbjg}}
            </el-form-item>
            <el-form-item label="投标价格" v-if="form.bjlx!=='1'">
                {{form.tbbj}}
            </el-form-item>

            <template v-if="form.ssxxz==='1'">
                <template v-if="form.bjlx==='1'">
                    <el-form-item label="评标价格(元)" prop="pbjg">
                        {{form.pbjg}}
                    </el-form-item>
                    <el-form-item label="中标价格(元)">
                        {{form.zbjg}}
                    </el-form-item>
                </template>
                <template v-if="form.bjlx!=='1'">
                    <el-form-item label="评标价格(元)">
                        {{form.pbbj}}
                    </el-form-item>
                    <el-form-item label="中标价格(元)">
                        {{form.zbbj}}
                    </el-form-item>
                </template>
            </template>

            <el-form-item label="评分结果" class="table-full-row">
                {{form.pfjg}}
            </el-form-item>
            <el-form-item label="工期" prop="construction_period">
                {{form.construction_period}}
            </el-form-item>
            <el-form-item label="项目负责人">
                {{form.pro_header}}
            </el-form-item>
            <el-form-item label="个人业绩">
                {{form.results}}
            </el-form-item>
            <el-form-item label="项目负责人证书及编号">
                {{form.certificate}}
            </el-form-item>
            <el-form-item label="中标候选人在投标文件中填报的资格能力条件" class="table-full-row">
                {{form.tender_ability}}
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [ FORM_PAGE_MIXIN],

    data: () => ({
        form: {},
        model:{},
        
    }),
    methods: {
        
        
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/hxredit.json`,{
            zhhxrcode:this.getQuery('zhhxrcode')
        }, data => {
            this.model = data
            this.form = data.json_model
        });
    },
    mounted() {
 
    },
}
</script>

<style scoped lang="scss">

</style>
